
  import * as D from '../data-utils';
  import $ from 'jquery';
  import App from '../app';
  import HistoryAPI from '../history';

  let history = new HistoryAPI();
  var offerdata = {};

  function init(context){
    var offers = getOffers(); //get all offers or only offers from current category if currentCategory is set
    var categories = getCategoriesWithOffers();  //get categories that has stores with offers, include relevant storeinfo into same array
    var lang = D.lang();
    var langs = D.langs();
    var translations = App.getTranslations(langs);

    var currentStoreId = getCurrentStoreId();
    //saved offerdata
    offerdata = getSavedOfferdata();

    if($.isEmptyObject(offerdata)){
      var allOffers = getAllOffers();
      offerdata = {
        offers,
        centerLogo: `/${context.imdHash}/imdlogo/${context.imdSettings.serverStartTime}`,
        offersCount: allOffers.length,
        categories,
        currentCategory: '',
        showByCategory: 0,
        iconsvg: context.resources.get('ic_offer'),
        icontitle: translations[lang]['common.tipsAndBenefits'],
        currentLang: lang,
        translations,
        lastposition: 0,
        scrollposition: 0
      };
    }

    history = new HistoryAPI('#tips', {
      categories,
      iconsvg: offerdata.iconsvg,
      offers,
      translations
    });

    if(currentStoreId){
      setPosition(0);
      setOffersByStore(currentStoreId);
    }
    return offerdata;
  }

  function getSavedOfferdata(){
    var currentOfferdata = App.getStoredData('currentOfferdata', 'all');
    return currentOfferdata;
  }

  function getCurrentStoreId(){
    var currentStoredata = App.getStoredData('currentStore', 'all');
    if(currentStoredata.store){
      return currentStoredata.store.id;
    }else{
      return false;
    }

  }

  function getOfferdata(){
    return offerdata;
  }

  function refreshOffers(){
    var offers = getOffers();
    offerdata.offers = offers;
  }

  function getAllOffers(){
    var lang = D.lang();
    var offersfeed = App.getStoredData('offers', lang);
    var offers = $.map(offersfeed.offers, function(offer){
      if(offer.store){
        var storeinfo = getStoreInfo(offer.store.id);
        $.each(storeinfo, function(i, store){
          offer.store.logo = store.logo;
          offer.store.category = store.category;
          offer.imagecount = 0;
        });
      }
      if(offer.images){
        offer.imagecount = offer.images.length;
      }
      return offer;
    });

    offerdata.offersCount = offers.length;

    return offers;
  }

  function getOffers(){
    var lang = D.lang();
    var offersfeed = App.getStoredData('offers', lang);
    var offers = $.map(offersfeed.offers, function(offer){
      if(offer.store){
        var storeinfo = getStoreInfo(offer.store.id);
        $.map(storeinfo, function(store){
          offer.store.logo = store.logo;
          offer.store.categories = store.categories;
          offer.imagecount = 0;
        });
        if(offer.images){
          offer.imagecount = offer.images.length;
        }
      }
      return offer;
    });

    return offers;
  }

  function getStoreInfo(id){
    var lang = D.lang();
    var storedata = App.getStoredData('storelist', lang);
    var data = $.map(storedata.stores, function(store){
      if(store.id==id){
        var categories = [];
        categories.push(store.fieldOfBusinessId);
        if(store.additionalFieldOfBusinessIds){
          $.each(store.additionalFieldOfBusinessIds, function(i, id){
            categories.push(id);
          });
        }
        return { logo: store.logoURL, categories: categories };
      }
    });
    return data;
  }

  function getCategoriesWithOffers(){
    var lang = D.lang();
    var scdata = App.getStoredData('scdata', lang);
    var cats = scdata.shoppingCenterData.fieldsOfBusiness;
    var storelist = App.getStoredData('storelist', lang);

    var storeswithoffers = $.map(cats, function(cat){
      var offerscount = 0;
      var stores = [];

      $.each(storelist.stores, function(i, store){
        if(store.id && store.offerCount>0){
          if(store.fieldOfBusinessId==cat.id){
            offerscount += store.offerCount;
            stores.push(store);
          }
          if(store.additionalFieldOfBusinessIds){

            $.each(store.additionalFieldOfBusinessIds, function(j, id){
              if(id == cat.id){
                offerscount += store.offerCount;
                if($.inArray(store, stores)<0){
                  stores.push(store);
                }
              }
            });
          }
        }
      });

      if(stores.length>0){
        cat.stores = stores;
        cat.offerscount = offerscount;
        return cat;
      }
    });

    return storeswithoffers;
  }

  //if category is set update offerlist to include only offers from that category
  function setOffersByCategory(id) {

    let offers;

    if(id=='all-offers'){
      offers = getAllOffers();
      offerdata.offers = offers;
    }
    else{
      offers = getOffers();
      var offersbycategory = [];
      $.each(offers, function(i, offer){
        $.each(offer.store.categories, function(j, category){
          if(category==id){
            offersbycategory.push(offer);
          }
        });

      });
      offerdata.offers = offersbycategory;
    }

  }

  function setOffersByStore(id){
    var offers = getOffers();
    var offersbystore = $.map(offers, function(offer){
      if(!!offer.store && offer.store.id==id){
        return offer;
      }
    });
    offerdata.offers = offersbystore;
  }

  function getCategory(id){
    var lang = D.lang();
    var scdata = App.getStoredData('scdata', lang);
    var categories = scdata.shoppingCenterData.fieldsOfBusiness;
    categories = $.map(categories, function(cat){
      if(cat.id == id){
        return cat;
      }
    });
    return categories;
  }

  function setCategory(id){
    offerdata.lastposition = offerdata.scrollposition;
    offerdata.scrollposition = 0;
    offerdata.currentCategory=id;
    offerdata.showByCategory=0;
    setOffersByCategory(id);
  }

  function toggleShowByCategory(){
    if(offerdata.showByCategory==0){
      offerdata.lastposition = offerdata.scrollposition;
      offerdata.scrollposition = 0;
      offerdata.showByCategory=1;
    }else{
      offerdata.showByCategory=0;
      offerdata.scrollposition = offerdata.lastposition;
    }

  }

  function setPosition(position){
    offerdata.lastposition = offerdata.scrollposition;
    offerdata.scrollposition = position;
  }

  function updateState(){
    history.updateState(offerdata);
  }

  function saveState(){
    history.saveState(offerdata);
  }

  function updateLastPosition (position) {
    offerdata.lastposition = position;
    App.saveLocally(offerdata, 'currentOfferdata', 'all');
  }

  function goBack(){
    const [historyState, state] = history.goBack();
    offerdata = state || offerdata;
    return !!historyState;
  }

export default {
    init,
    getOfferdata,
    getOffers,
    refreshOffers,
    setOffersByCategory,
    setOffersByStore,
    setCategory,
    toggleShowByCategory,
    setPosition,
    saveState,
    updateState,
    updateLastPosition,
    goBack
  };
